import { SearchFilter, ZonedDateTimeRange } from '@rygen/rygen-ui/model';

import { ShipOrder } from '../ShipOrder';

export class ShipOrderSearchCriteria extends SearchFilter<ShipOrder> {
  shipOrderIds?: number[];
  originLocationId?: number;
  originLocationCode?: string;
  originLocationName?: string;
  originCity?: string;
  originState?: string;
  originPostalCode?: string;
  originCountry?: string;
  destinationLocationId?: number;
  destinationLocationCode?: string;
  destinationLocationName?: string;
  destinationCity?: string;
  destinationState?: string;
  destinationPostalCode?: string;
  destinationCountry?: string;
  requestedPickupDateRange?: ZonedDateTimeRange;
  requestedDeliveryDateRange?: ZonedDateTimeRange;

  constructor(opts?: Partial<ShipOrderSearchCriteria>) {
    super(opts);

    if (opts?.shipOrderIds != null) {
      this.shipOrderIds = opts.shipOrderIds;
    }
    if (opts?.originLocationId != null) {
      this.originLocationId = opts.originLocationId;
    }
    if (opts?.originLocationCode != null) {
      this.originLocationCode = opts.originLocationCode;
    }
    if (opts?.originLocationName != null) {
      this.originLocationName = opts.originLocationName;
    }
    if (opts?.originCity != null) {
      this.originCity = opts.originCity;
    }
    if (opts?.originState != null) {
      this.originState = opts.originState;
    }
    if (opts?.originPostalCode != null) {
      this.originPostalCode = opts.originPostalCode;
    }
    if (opts?.originCountry != null) {
      this.originCountry = opts.originCountry;
    }
    if (opts?.destinationLocationId != null) {
      this.destinationLocationId = opts.destinationLocationId;
    }
    if (opts?.destinationLocationCode != null) {
      this.destinationLocationCode = opts.destinationLocationCode;
    }
    if (opts?.destinationLocationName != null) {
      this.destinationLocationName = opts.destinationLocationName;
    }
    if (opts?.destinationCity != null) {
      this.destinationCity = opts.destinationCity;
    }
    if (opts?.destinationState != null) {
      this.destinationState = opts.destinationState;
    }
    if (opts?.destinationPostalCode != null) {
      this.destinationPostalCode = opts.destinationPostalCode;
    }
    if (opts?.destinationCountry != null) {
      this.destinationCountry = opts.destinationCountry;
    }
    if (opts?.requestedPickupDateRange != null) {
      this.requestedPickupDateRange = new ZonedDateTimeRange(
        opts.requestedPickupDateRange,
      );
    }
    if (opts?.requestedDeliveryDateRange != null) {
      this.requestedDeliveryDateRange = new ZonedDateTimeRange(
        opts.requestedDeliveryDateRange,
      );
    }
    if (opts?.sortField != null) {
      this.sortField = opts.sortField;
    } else {
      this.sortField = undefined;
    }
  }
}
